/* eslint-disable no-unused-vars */
export enum DocumentsCategory {
  FORM_I_9 = 'FORM-I-9',

  W4_FORM = 'W4-FORM',

  EMPLOYMENT_VERIFICATION = 'EMPLOYMENT-VERIFICATION',

  SOCIAL_SECURITY_NUMBER = 'SOCIAL-SECURITY-NUMBER',

  DRIVERS_LICENSE = 'DRIVER-LICENSE',

  PASSPORT = 'PASSPORT',

  VISA_DOCUMENTS = 'VISA-DOCUMENTS',

  DIRECT_DEPOSIT_FORM = 'DIRECT-DEPOSIT-FORM',

  VOIDED_CHECK_BANK_LETTER = 'VOIDED-CHECK-BANK-LETTER',

  VACCINATION_CARD = 'VACCINATION-CARDS',

  OTHERS = 'OTHERS',
}
